// Hilfsfunktionen zur Änderungserkennung der Terminplanungs-Sidebar
import { stripBrackets } from '@/core/common/helpers/utils';

// Prüft, ob ein Inlandsflug gegenüber seinem geladenen Ursprungsstand (valuesBeforeEdit) unverändert ist
export function isInlandsflugUnchanged(inlandsflug) {
  const before = inlandsflug.valuesBeforeEdit;
  return (
    before.tag === inlandsflug.tag &&
    before.einkauf === inlandsflug.einkauf &&
    before.fruehesterAbflug?.substring(0, 5) === inlandsflug.fruehesterAbflug?.substring(0, 5) &&
    before.spaetesteAnkunft?.substring(0, 5) === inlandsflug.spaetesteAnkunft?.substring(0, 5) &&
    stripBrackets(JSON.stringify(before.zielflughafenIataCode)) ===
      stripBrackets(JSON.stringify(inlandsflug.zielflughafenIataCode)) &&
    stripBrackets(JSON.stringify(before.abflughafenIataCode)) ===
      stripBrackets(JSON.stringify(inlandsflug.abflughafenIataCode)) &&
    before.minimaleUmsteigezeit === inlandsflug.minimaleUmsteigezeit
  );
}
